import React, { useEffect, useContext, useRef } from "react";

import qs from "qs";
import { useNavigate, useLocation } from "react-router-dom";
import { postAuth, requestAutorizationCode } from "../../services/api/auth-api";

import UserContext from "../../context/userContext";
import PageLoading from "../Globo/PageLoading/PageLoading";
import {
  current,
  handleLogin,
  logout,
} from "../../shared/constants/login-store";
import { getAndClearRedirectUrl } from "../../shared/constants/redirect-store";

function Auth() {
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const authInitiatedRef = useRef(false);

  const redirectToRootPage = () => {
    const storedRedirect = getAndClearRedirectUrl();

    if (storedRedirect && storedRedirect.trim()) {
      navigate(storedRedirect.trim());
    } else if (
      location.state &&
      !!location.state.redirect &&
      location.state.redirect.trim()
    ) {
      let url = location.state.redirect.trim();

      let to = url.toString().replace(window.location.origin, "");

      to = to.indexOf("/") === 0 ? to : `/${to}`;

      navigate(to);
    } else {
      navigate(`/`);
    }
  };

  const redirectToLoginWithError = () => {
    // Clear invalid tokens to prevent further 401 errors
    logout();
    // Clear redirect URL to prevent loops
    getAndClearRedirectUrl();
    // Redirect to login instead of logout to break the /auth → /logout loop
    window.location = "/login?error=auth_failed";
  };
  const redirectToLogoutPage = () => {
    window.location = "/logout";
  };
  const redirectToUnauthorizedPage = () => {
    window.location = "/acesso-negado";
  };

  // CultureHub always lands on the Culture Hub once, right after login, even if they hold other roles too
  const redirectAfterAuth = (user) => {
    if (user?.roles?.includes("CultureHub")) {
      navigate("/hub-cultura");
    } else {
      redirectToRootPage();
    }
  };

  useEffect(() => {
    // Prevent double execution of auth flow (especially in React StrictMode)
    if (authInitiatedRef.current) {
      return;
    }
    authInitiatedRef.current = true;

    let _params = window.location.search;
    if (_params) _params = _params.substr(1);

    const parsedParams = qs.parse(_params);

    //Verifica se há comando de autenticação
    if (!current()) {
      if (parsedParams["code"]) {
        postAuth(parsedParams)
          .then((tokens) => {
            handleLogin(tokens);
            userContext.setUserIsAuthenticated(true);
            Promise.all([userContext.getRoles(), userContext.loadOrCreateUser()])
              .then(([user]) => {
                redirectAfterAuth(user);
              })
              .catch((e) => {
                console.error("Failed to load user roles:", e);
                userContext.setUserIsAuthenticated(false);
                // If tokens were invalid, redirect to login to retry authentication
                redirectToLoginWithError();
              });
          })
          .catch((e) => {
            console.error("Auth code exchange failed:", e);
            //Force the user's logout when the request token failed.
            userContext.setUserIsAuthenticated(false);
            // Redirect to login with error instead of logout to break the auth loop
            redirectToLoginWithError();
          });
      } else {
        requestAutorizationCode();
      }
    } else {
      Promise.all([userContext.getRoles(), userContext.loadOrCreateUser()])
        .then(([user]) => {
          redirectAfterAuth(user);
        })
        .catch((e) => {
          console.error("Failed to load user roles during re-auth:", e);
          userContext.setUserIsAuthenticated(false);
          // Clear tokens and redirect to login to re-authenticate
          redirectToLoginWithError();
        });
    }

    // eslint-disable-next-line
  }, []);

  return <PageLoading message="Redirecionando, aguarde." />;
}

export default Auth;
